import { useState } from "react";
import { API_URL } from "../pages/config";

const field =
  "mt-2 w-full border-b border-border bg-transparent pb-2 text-base text-foreground outline-none transition-colors placeholder:text-muted-foreground/60 focus:border-primary";
const label = "block text-sm text-muted-foreground";

export function ContactForm() {
  const [status, setStatus] = useState("idle"); // idle | sending | sent | error

  async function onSubmit(event) {
    event.preventDefault();
    const form = event.currentTarget;
    setStatus("sending");
    try {
      const res = await fetch(`${API_URL}/api/contact`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(Object.fromEntries(new FormData(form))),
      });
      if (!res.ok) throw new Error(res.status);
      form.reset();
      setStatus("sent");
    } catch {
      setStatus("error");
    }
  }

  if (status === "sent") {
    return (
      <p className="mt-10 max-w-xl text-lg leading-relaxed text-foreground">
        Thank you. Your message has reached our team and we will get back to you soon.
      </p>
    );
  }

  return (
    <form onSubmit={onSubmit} className="mt-10 max-w-xl">
      <div className="grid gap-8 sm:grid-cols-2 sm:gap-x-12">
        <div>
          <label className={label} htmlFor="name">
            Name
          </label>
          <input id="name" name="name" required maxLength={120} className={field} />
        </div>
        <div>
          <label className={label} htmlFor="email">
            Work email
          </label>
          <input id="email" name="email" type="email" required maxLength={200} className={field} />
        </div>
      </div>

      <div className="mt-8">
        <label className={label} htmlFor="organisation">
          Organisation
        </label>
        <input id="organisation" name="organisation" maxLength={160} className={field} />
      </div>

      <div className="mt-8">
        <label className={label} htmlFor="message">
          What are you trying to solve?
        </label>
        <textarea
          id="message"
          name="message"
          required
          minLength={10}
          maxLength={4000}
          rows={4}
          className={field + " resize-none"}
        />
      </div>

      <div className="mt-10 flex flex-wrap items-center gap-x-8 gap-y-4">
        <button type="submit" disabled={status === "sending"} className="btn-base btn-signal">
          {status === "sending" ? "Sending…" : "Get in touch"}
        </button>
        <a
          href="mailto:hello@blippai.com"
          className="text-base text-muted-foreground transition-colors hover:text-foreground"
        >
          hello@blippai.com
        </a>
      </div>

      {status === "error" ? (
        <p className="mt-6 text-base text-muted-foreground">
          Something went wrong. You can also email hello@blippai.com directly.
        </p>
      ) : null}
    </form>
  );
}
